export default __webpack_public_path__ + "static/10-944d5940c3973a3d5ecdf2e0a66f568a.jpg";